module.exports = __webpack_public_path__ + "static/screenshot1-f4e576545d514c69d3fd13dff8e671cc.png";